export const SORT_DIRECTION_LIST = [
  {
    value: "ASC",
    label: "ASC",
  },
  {
    value: "DESC",
    label: "DESC",
  },
];
